import { render, staticRenderFns } from "./todolist-index.vue?vue&type=template&id=ecd03b98&scoped=true&"
import script from "./todolist-index.vue?vue&type=script&lang=js&"
export * from "./todolist-index.vue?vue&type=script&lang=js&"
import style0 from "./todolist-index.vue?vue&type=style&index=0&id=ecd03b98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd03b98",
  null
  
)

export default component.exports